import Ray from './component';
import { lineTool } from '../shared/line';

export const tool = lineTool('ray', Ray);
